import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getSearchDataModeActive } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, SetExpandTokens } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";

replaceInChain(chain, SetExpandTokens, props => {
    props.expandTokens = ["attributes", "facets", "variantTraits", "badges", "properties"];

    if (getSearchDataModeActive(props.getState())) {
        props.expandTokens.push("scoreexplanation");
    }
})